import { HttpEvent, HttpInterceptorFn, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/modules/auth/auth.service';
import { environment } from 'environments/environment';
import { Observable, catchError, throwError } from 'rxjs';
import { Helpers } from '../helpers/helpers';

export const baseInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  let httpParams = new HttpParams();

  const isAbsolute = req.url.startsWith('http');
  const isSelfHost = !isAbsolute || req.url.startsWith(environment.baseUrl);
  if (isAbsolute && !isSelfHost) {
    return next(req);
  }
  const urlSplit = req.url.split('?');
  if (urlSplit.length === 2) {
    req = req.clone({ url: urlSplit[0] });

    const queryParamsSplit = urlSplit[1].split('&');
    queryParamsSplit.forEach((value) => {
      const splitValue = value.split('=');
      const key = splitValue[0];
      const keyValue = splitValue.slice(1).join('=');

      if (httpParams.has(key)) {
        httpParams = httpParams.append(key, keyValue);
      } else {
        httpParams = httpParams.set(key, keyValue);
      }
    });

    req.params.keys().forEach((key) => {
      if (httpParams.has(key)) {
        httpParams = httpParams.append(key, req.params.getAll(key)[0]);
      } else {
        httpParams = httpParams.set(key, req.params.getAll(key)[0]);
      }
    });

    if (httpParams.keys().length > 0) {
      req = req.clone({ params: httpParams });
    }
  }

  // encryption
  if (environment.eptEnabled && req.method === 'GET' && req.params.keys().length > 0) {
    httpParams = new HttpParams();
    const paramsObject: { [key: string]: any } = {};
    req.params.keys().forEach((key) => {
      const value = req.params.getAll(key).length > 1 || key.includes('[]') ? req.params.getAll(key) : req.params.getAll(key)[0];
      key = key.replace('[]', '');
      paramsObject[key] = value;
    });

    const encryptedParams = Helpers.encryptData(paramsObject);
    httpParams = httpParams.set('xyz', encryptedParams);

    req = req.clone({
      params: httpParams,
    });
  }

  // auth
  const token = authService.getToken();
  const url = isAbsolute ? req.url : `${environment.baseUrl}/${req.url}`.replace(/([^:])\/\//g, '$1/');
  const newReq = req.clone({
    setHeaders: {
      Authorization: token ? `Bearer ${token}` : '',
    },
    url,
  });

  return next(newReq).pipe(
    catchError((error) => {
      if (error.status === 401 && !req.url.includes('auth/change-expired-password') && error.error?.error !== 'invalid_credentials') {
        authService.clearSession();
        location.href = 'login';
      }
      if (error.error instanceof Blob && error.error.type === 'application/json') {
        return new Observable<HttpEvent<unknown>>((observer) => {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const parsed = JSON.parse(reader.result as string);
              observer.error({ ...error, error: parsed, message: parsed?.message || error.message });
            } catch {
              observer.error({ ...error, message: 'An unexpected error occurred.' });
            }
          };
          reader.onerror = () => observer.error({ ...error, message: 'An unexpected error occurred.' });
          reader.readAsText(error.error);
        });
      }

      const backendMessage = typeof error.error === 'object' && error.error !== null ? error.error.message : undefined;
      if (backendMessage) {
        return throwError(() => ({ ...error, message: backendMessage }));
      }
      return throwError(() => error);
    })
  );
};
